// Quantity selector button handling
document.addEventListener('DOMContentLoaded', function () {
    const showStockAlert = function (maxVal) {
        const alertAttributes = {
            message: `Only ${maxVal} items are available in stock.`,
            type: 'info',
        };
        const showAlertEvent = new CustomEvent('showAlert', {
            detail: alertAttributes,
        });
        window.dispatchEvent(showAlertEvent);
    };

    document.querySelectorAll('.qty-selector').forEach(function (container) {
        const input = container.querySelector('input[type="number"]');
        const minusBtn = container.querySelector('.qty-minus');
        const plusBtn = container.querySelector('.qty-plus');
        if (!input) return;
        const step = parseFloat(input.getAttribute('step')) || 1;
        const min = parseFloat(input.getAttribute('min')) || 0;

        if (minusBtn) {
            minusBtn.addEventListener('click', function () {
                let val = parseFloat(input.value) || 0;
                val = Math.max(min, val - step);
                input.value = val;
                input.dispatchEvent(new Event('change'));
            });
        }
        if (plusBtn) {
            plusBtn.addEventListener('click', function () {
                const max = parseFloat(input.getAttribute('max')) || Infinity;
                let val = parseFloat(input.value) || 0;
                if (val >= max) {
                    showStockAlert(max);
                    return;
                }
                val = val + step;
                input.value = val;
                input.dispatchEvent(new Event('change'));
            });
        }

        input.addEventListener('change', function () {
            const max = parseFloat(input.getAttribute('max')) || Infinity;
            let val = parseFloat(input.value);
            if (isNaN(val)) val = min;
            if (val > max) {
                input.value = max;
                showStockAlert(max);
            }
        });
    });

    // Sync inputs that have data-link attributes
    document.querySelectorAll('input[data-link]').forEach(function (input) {
        input.addEventListener('change', function () {
            const targetSelector = input.getAttribute('data-link');
            const targetInput = targetSelector ? document.querySelector(targetSelector) : null;
            if (targetInput && targetInput.value !== input.value) {
                targetInput.value = input.value;
                targetInput.dispatchEvent(new Event('change'));
            }
        });
    });
});

// Adds the last clicked collection product card to breadcrumbs when the product
// URL does not include Shopify collection context.
document.addEventListener('DOMContentLoaded', function () {
    const breadcrumbList = document.querySelector('.template-product .shopify-section-breadcrumbs nav[aria-label="breadcrumbs"] ol');

    if (!breadcrumbList || breadcrumbList.children.length !== 2) return;

    try {
        const lastCollection = JSON.parse(window.localStorage.getItem('lastCollectionBreadcrumb'));

        if (
            !lastCollection ||
            !lastCollection.title ||
            !lastCollection.url ||
            !lastCollection.productUrl ||
            new URL(lastCollection.productUrl, window.location.origin).pathname !== window.location.pathname
        ) {
            return;
        }

        const collectionItem = document.createElement('li');
        const collectionLink = document.createElement('a');

        collectionLink.href = lastCollection.url;
        collectionLink.textContent = lastCollection.title;
        collectionItem.appendChild(collectionLink);
        breadcrumbList.insertBefore(collectionItem, breadcrumbList.lastElementChild);
        window.localStorage.removeItem('lastCollectionBreadcrumb');
    } catch (error) {}
});

// Bold the monthly payment amount inside the Synchrony/SYF offer on PDP pages.
document.addEventListener('DOMContentLoaded', function () {
    const syfWidget = document.querySelector('#syf-unifi-widget');

    if (!syfWidget) return;

    function updateSyfText() {
        syfWidget.querySelectorAll('.syf-offer span').forEach(function (el) {
            if (el.querySelector('strong')) return;

            const html = el.innerHTML;
            const updated = html.replace(/(\$\d+(?:,\d{3})*(?:\.\d{2})?\/mo)/, '<strong>$1</strong>');

            if (updated !== html) {
                el.innerHTML = updated;
            }
        });
    }

    updateSyfText();

    if ('MutationObserver' in window) {
        const observer = new MutationObserver(updateSyfText);

        observer.observe(syfWidget, {
            childList: true,
            subtree: true
        });
    }
});
